// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"83b3f0fdc7b910bfc832","691":"4492c6c5ca96fddaae9f"}[chunkId] + ".js";
};